import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  & > div {
    margin-bottom: 12px;
    display: flex;
  }
  @media ${DEVICES.sm} {
    align-items: flex-start;
  }
`;

